<template>
    <div v-if="hasCommands" class="rvp-grid mb-3">
        <template v-if="isNs20">
            <div v-if="balise.securityMode !== 'NOT_SUPPORTED'" class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">Sécurité - verrouillage :</span>
                    <span class="rvp-command-state">{{ securityModeLabel }}</span>
                </div>

                <div v-if="!actionLoading.security" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="executeAction(121, 'security')">
                        Activer
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger rvp-command-btn"
                        @click="executeAction(122, 'security')">
                        Désactiver
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>

            <div v-if="balise.carjackingMode !== 'NOT_SUPPORTED'" class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">Coupure pédale :</span>
                    <span class="rvp-command-state">{{ carjackingModeLabel }}</span>
                </div>

                <div v-if="!actionLoading.pedal" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="executeAction(119, 'pedal')">
                        Activer
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger rvp-command-btn"
                        @click="executeAction(120, 'pedal')">
                        Désactiver
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>

            <div v-if="($isOperator || $isAdmin) && balise.featureCallback" class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">Contre-appel :</span>
                </div>

                <div v-if="!actionLoading.callback" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="executeAction(125, 'callback')">
                        Mitry
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="executeAction(126, 'callback')">
                        Goussainville
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>
        </template>

        <template v-else-if="isAt35">
            <div class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">{{ at35OutputLabel(1).label }}</span>
                    <span class="rvp-command-state">
                        <strong v-if="at35OutputLabel(1).suffix">
                            {{ at35OutputLabel(1).suffix }}
                        </strong>
                    </span>
                </div>

                <div v-if="!actionLoading.at35Security" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="runRegistered(129, 'at35Security')">
                        Activer
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger rvp-command-btn"
                        @click="runRegistered(130, 'at35Security')">
                        Désactiver
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>

            <div class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">{{ at35OutputLabel(4).label }}</span>
                    <span class="rvp-command-state">
                        <strong v-if="at35OutputLabel(4).suffix">
                            {{ at35OutputLabel(4).suffix }}
                        </strong>
                    </span>
                </div>

                <div v-if="!actionLoading.at35Starter" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="runRegistered(131, 'at35Starter')">
                        Activer
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger rvp-command-btn"
                        @click="runRegistered(132, 'at35Starter')">
                        Désactiver
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>

            <div class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">{{ at35OutputLabel(3).label }}</span>
                    <span class="rvp-command-state">
                        <strong v-if="at35OutputLabel(3).suffix">
                            {{ at35OutputLabel(3).suffix }}
                        </strong>
                    </span>
                </div>

                <div v-if="!actionLoading.at35Siren" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="runRegistered(133, 'at35Siren')">
                        Activer
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger rvp-command-btn"
                        @click="runRegistered(134, 'at35Siren')">
                        Désactiver
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>

            <div class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">{{ at35OutputLabel(2).label }}</span>
                    <span class="rvp-command-state">
                        <strong v-if="at35OutputLabel(2).suffix">
                            {{ at35OutputLabel(2).suffix }}
                        </strong>
                    </span>
                </div>

                <div v-if="!actionLoading.at35Jamming" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="runRegistered(135, 'at35Jamming')">
                        Activer
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-danger rvp-command-btn"
                        @click="runRegistered(136, 'at35Jamming')">
                        Désactiver
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>

            <div v-if="($isOperator || $isAdmin) && balise.featureCallback" class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">Contre-appel :</span>
                </div>

                <div v-if="!actionLoading.at35Callback" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="runRegistered(138, 'at35Callback')">
                        Mitry
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-primary rvp-command-btn"
                        @click="runRegistered(137, 'at35Callback')">
                        Goussainville
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>

            <div v-if="$isOperator || $isAdmin" class="rvp-command-row">
                <div class="rvp-command-meta">
                    <span class="rvp-command-label">Maintenance :</span>
                </div>

                <div v-if="!actionLoading.at35Maintenance" class="rvp-command-actions">
                    <button type="button" class="btn btn-sm btn-outline-secondary rvp-command-btn"
                        @click="runRegistered(139, 'at35Maintenance')">
                        CREP
                    </button>
                    <button type="button" class="btn btn-sm btn-outline-secondary rvp-command-btn"
                        @click="runRegistered(140, 'at35Maintenance')">
                        Reboot
                    </button>
                </div>
                <div v-else class="rvp-command-actions">
                    <div class="rvp-command-loading">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import CmdService from '@/services/cmd.service'

export default {
    name: 'VehicleCommands',
    props: {
        balise: { type: Object, required: true },
    },
    data() {
        return {
            actionLoading: {
                security: false,
                pedal: false,
                callback: false,
                at35Security: false,
                at35Starter: false,
                at35Siren: false,
                at35Jamming: false,
                at35Callback: false,
                at35Maintenance: false,
            },
            actionLoadingDurations: {
                security: 5000,
                pedal: 5000,
                callback: 10000,
                at35Security: 5000,
                at35Starter: 5000,
                at35Siren: 5000,
                at35Jamming: 5000,
                at35Callback: 10000,
                at35Maintenance: 5000,
            },
            actionLoadingTimers: {
                security: null,
                pedal: null,
                callback: null,
                at35Security: null,
                at35Starter: null,
                at35Siren: null,
                at35Jamming: null,
                at35Callback: null,
                at35Maintenance: null,
            },
        };
    },
    computed: {
        isNs20() {
            return this.balise?.type === 'NS20';
        },
        isAt35() {
            return this.balise?.type === 'AT35';
        },
        isClientViewer() {
            return this.$store.state.auth.user?.role === 'clientviewer';
        },
        hasCommands() {
            return !this.isClientViewer && (this.isNs20 || this.isAt35);
        },
        securityModeLabel() {
            switch (this.balise?.securityMode) {
                case 'ACTIVE':
                    return 'Activée';
                case 'INACTIVE':
                    return 'Désactivée';
                default:
                    return '';
            }
        },
        carjackingModeLabel() {
            switch (this.balise?.carjackingMode) {
                case 'ACTIVE':
                    return 'Activée';
                case 'INACTIVE':
                    return 'Désactivée';
                default:
                    return '';
            }
        },
    },
    beforeUnmount() {
        Object.values(this.actionLoadingTimers).forEach((timer) => {
            if (timer) {
                clearTimeout(timer);
            }
        });
    },
    methods: {
        async executeAction(cmdId, loadingKey) {
            await this.runCommand(
                () => CmdService.executeAction(this.balise.id, cmdId),
                loadingKey
            );
        },
        async runRegistered(cmdId, loadingKey) {
            await this.runCommand(
                () => CmdService.runRegistered(this.balise.id, cmdId),
                loadingKey
            );
        },
        async runCommand(callback, loadingKey) {
            if (!this.balise?.id || this.actionLoading[loadingKey]) {
                return;
            }

            this.actionLoading[loadingKey] = true;

            if (this.actionLoadingTimers[loadingKey]) {
                clearTimeout(this.actionLoadingTimers[loadingKey]);
            }

            this.actionLoadingTimers[loadingKey] = setTimeout(() => {
                this.actionLoading[loadingKey] = false;
                this.actionLoadingTimers[loadingKey] = null;
            }, this.actionLoadingDurations[loadingKey] ?? 5000);

            try {
                await callback();
            } catch (e) {
                console.error('Erreur commande véhicule', e);
            }
        },
        at35OutputLabel(index) {
            const io = this.balise?.digitalIOs?.find((item) => {
                return item.ioType === 'OUTPUT' && Number(item.index) === Number(index);
            });

            if (!io) {
                return {
                    label: '',
                    suffix: '',
                };
            }

            const outputName = io.value ? io.onName : io.offName;

            if (!outputName) {
                return {
                    label: '',
                    suffix: '',
                };
            }

            const separatorIndex = outputName.indexOf(':');

            if (separatorIndex === -1) {
                return {
                    label: outputName,
                    suffix: '',
                };
            }

            return {
                label: outputName.slice(0, separatorIndex + 1),
                suffix: outputName.slice(separatorIndex + 1),
            };
        },
    },
};
</script>

<style scoped>
.rvp-grid {
    display: grid;
    gap: .6rem;
}

.rvp-command-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: .6rem;
    padding: .25rem .1rem;
    border-bottom: 1px dashed #f1f3f5;
    flex-wrap: wrap;
}

.rvp-command-row:last-child {
    border-bottom: 0;
    margin-bottom: .4rem;
}

.rvp-command-meta {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .45rem;
    min-width: 0;
    flex: 1 1 12rem;
}

.rvp-command-label {
    font-size: .82rem;
    font-weight: 600;
    color: #495057;
    white-space: normal;
}

.rvp-command-state {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 3.2rem;
    padding: .12rem .45rem;
    border-radius: 999px;
    font-size: .68rem;
    font-weight: 700;
    letter-spacing: .03em;
    border: 1px solid transparent;
    white-space: nowrap;
}

.rvp-command-actions {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: .35rem;
    min-width: 0;
    flex: 0 1 auto;
}

.rvp-command-loading {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 5.5rem;
    min-height: 1.9rem;
}

.rvp-command-btn {
    padding: .18rem .5rem;
    font-size: .72rem;
    line-height: 1.2;
    border-radius: .55rem;
    white-space: nowrap;
}
</style>